import { Box, HStack, Spacer, Text, VStack } from "native-base";
import React from "react";

const TableRow = ({ title, value, borderBottomWidth }) => {
	return (
		<Box
			borderBottomWidth={borderBottomWidth || "1"}
			_dark={{
				borderColor: "gray.600",
			}}
			borderColor="coolGray.200"
			p={4}
		>
			<HStack space={5} justifyContent="space-between">
				<VStack>
					<Text
						_dark={{
							color: "warmGray.50",
						}}
						color="coolGray.600"
						fontWeight="900"
					>
						{title}
					</Text>
				</VStack>
				<Spacer />
				<Text
					fontSize="xs"
					_dark={{
						color: "warmGray.50",
					}}
					color="coolGray.800"
					alignSelf="flex-start"
					numberOfLines={2}
				>
					{value}
				</Text>
			</HStack>
		</Box>
	);
};
export default TableRow;
